import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage.service';
import { STORAGE_KEYS, UserRole } from '../constants/app-constants';

/**
 * Guard that checks staff user permissions for specific routes.
 * Super admins bypass all permission checks.
 * Staff users are checked against their stored permissions.
 * Other roles (vendor/driver) are denied access to admin routes.
 *
 * Usage in routes:
 *   canActivate: [permissionGuard('vendors')]
 */
export function permissionGuard(permissionKey: string): CanActivateFn {
  return () => {
    const storage = inject(StorageService);
    const router = inject(Router);

    const role = storage.get(STORAGE_KEYS.USER_ROLE);

    // Super admin has access to everything
    if (role === UserRole.SUPER_ADMIN) return true;

    // Staff users — check specific permission
    if (role === UserRole.STAFF) {
      const permissions = storage.getJson<Record<string, boolean>>(STORAGE_KEYS.STAFF_PERMISSIONS) ?? {};
      if (permissions[permissionKey] === true) return true;

      // Redirect to dashboard if no permission
      router.navigate(['/dashboard']);
      return false;
    }

    // Other roles don't have access to admin routes
    router.navigate(['/dashboard']);
    return false;
  };
}
